import { Button } from '@mentalgrowth/ui-kit-web';
import type { TpButtonProps } from '@mentalgrowth/ui-kit-web';
import type { RefObject } from 'react';

export const UiKitButton = (
  props: TpButtonProps & {
    ref?: RefObject<HTMLButtonElement>;
  },
) => <Button {...props} />;
